export default {
    'it-IT': {
        popUpTitle: 'BIG DEALS. GREAT SEASON',
        popUpText:
            'È tempo di prepararsi alla nuova stagione! Per conoscere in anticipo tutte le promozioni e le iniziative, iscriviti alla newsletter LORDGUN!',
        popUpButtonText: 'Mi iscrivo!',
    },
    'fr-FR': {
        popUpTitle: 'BIG DEALS. GREAT SEASON',
        popUpText:
            "Il est temps de se préparer à la nouvelle saison ! Pour connaître à l'avance toutes les promotions et initiatives, inscrivez-vous à la newsletter LORDGUN !",
        popUpButtonText: "Je m'inscris !",
    },
    'es-ES': {
        popUpTitle: 'BIG DEALS. GREAT SEASON',
        popUpText:
            '¡Es hora de prepararse para la nueva temporada! Para enterarte con antelación de todas las promociones e iniciativas, ¡apúntate al boletín de LORDGUN!',
        popUpButtonText: '¡Me suscribo!',
    },
    'en-GB': {
        popUpTitle: 'BIG DEALS. GREAT SEASON',
        popUpText:
            "It's time to get ready for the new season! To find out about all the promotions and initiatives in advance, sign up for the LORDGUN newsletter!",
        popUpButtonText: 'I subscribe!',
    },
    'en-US': {
        popUpTitle: 'BIG DEALS. GREAT SEASON',
        popUpText:
            "It's time to get ready for the new season! To find out about all the promotions and initiatives in advance, sign up for the LORDGUN newsletter!",
        popUpButtonText: 'I subscribe!',
    },
    'de-DE': {
        popUpTitle: 'BIG DEALS. GREAT SEASON',
        popUpText:
            'Es ist an der Zeit, sich auf die neue Saison vorzubereiten! Um über alle Aktionen und Angebote im Voraus informiert zu werden, melden Sie sich für den LORDGUN-Newsletter an!',
        popUpButtonText: 'Ich melde mich an!',
    },
    'en-AU': {
        popUpTitle: 'BIG DEALS. GREAT SEASON',
        popUpText:
            "It's time to get ready for the new season! To find out about all the promotions and initiatives in advance, sign up for the LORDGUN newsletter!",
        popUpButtonText: 'I subscribe!',
    },
};
